<template>
    <b-card no-body>
        <v-table    ref="table"
                    :buttons="buttons"
                    name="template"
                    :fields="fields"
                    pagination="server"
                    :items-provider="provider"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import TemplateGeneratorApi from '@/api/template-generator'
export default {
    components:{
        BCard
    },
    data(){
        return{
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit }
            ],
            fields:[
                {name:"Şablon",key:"Name",thClass:"w-20"},
                {name:"Açıklama",key:"Description",thClass:"w-80"}
            ]
        }
    },
    methods:{
        provider(data){
            return TemplateGeneratorApi.Table(data)
        },
        edit(item){
            this.$router.push({name:'template-generator',params:{id:item.Id}})
        },
    }
}
</script>

<style>

</style>